const extractHostname = (url: string) =>
  new URL(url).hostname.replace("www.", "");

export default extractHostname;
